import { render, staticRenderFns } from "./ExercisesFromWorkout.vue?vue&type=template&id=6ccb3d96&scoped=true&"
import script from "./ExercisesFromWorkout.vue?vue&type=script&lang=js&"
export * from "./ExercisesFromWorkout.vue?vue&type=script&lang=js&"
import style0 from "./ExercisesFromWorkout.vue?vue&type=style&index=0&id=6ccb3d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb3d96",
  null
  
)

export default component.exports